export default function (gpUser) {
    return {
        username: gpUser.Username || 'Player',
        msisdn: gpUser.Msisdn,
        status: getStatus(gpUser.Status),
        subscriptionId: gpUser.SubscriptionId,
        campaignId: gpUser.CampaignId,
        activatedAt: gpUser.DateAdded,
        optInServiceMsgs: gpUser.OptInServiceMsgs,
        optInContentMsgs: gpUser.OptInServiceMsgs,
        avatar: gpUser.Avatar || 1,
        automatedEntries: gpUser.AutomatedEntries,
        freePlayService: gpUser.FreeToPlay,
        serviceId: gpUser.Service || gpUser.ServiceId,
        externalRef: 12335642,
    }
}

function getStatus(status) {
    if (status.toLowerCase() === 'pending' || 'active') return 'Active'
    else return 'Cancelled'
}